/**
 * Resolve insurer display names for the landing banner/companies carousel.
 */
export function getActiveCompanyIds(activeProducts = {}) {
    return Array.from(
        new Set(
            Object.values(activeProducts)
                .flatMap((product) => product?.codigos_aseguradoras || [])
                .map((el) => el?.id_aseguradora)
                .filter((id) => id != null)
        )
    );
}

export function resolveCompanyNames(companyIds, companiesIdDict = {}) {
    return companyIds
        .map((companyId) => companiesIdDict?.[companyId] ?? companiesIdDict?.[Number(companyId)])
        .filter(Boolean);
}

export function getActiveCompanyNames(activeProducts = {}, companiesIdDict = {}) {
    return resolveCompanyNames(getActiveCompanyIds(activeProducts), companiesIdDict);
}
